import { useEffect } from 'react';

interface MetaConfig {
  title?: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string;
  canonical?: string;
  robots?: string;
}

const SITE_URL = 'https://www.proptpilot.com';

export const useMeta = (config: MetaConfig) => {
  useEffect(() => {
    if (config.title) {
      document.title = config.title;
    }

    const updateMetaTag = (name: string, content: string, property?: boolean) => {
      if (!content) return;
      const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let element = document.querySelector(selector) as HTMLMetaElement | null;
      if (!element) {
        element = document.createElement('meta');
        if (property) {
          element.setAttribute('property', name);
        } else {
          element.setAttribute('name', name);
        }
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    const updateCanonical = (href: string) => {
      if (!href) return;
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', href);
    };

    updateMetaTag('description', config.description || '');
    updateMetaTag('keywords', config.keywords || '');
    updateMetaTag('robots', config.robots || 'index, follow');

    updateMetaTag('og:site_name', 'ProptPilot', true);
    updateMetaTag('og:locale', 'en_GB', true);
    updateMetaTag('og:title', config.ogTitle || config.title || '', true);
    updateMetaTag('og:description', config.ogDescription || config.description || '', true);
    updateMetaTag('og:image', config.ogImage || `${SITE_URL}/lovable-uploads/924a6ca1-11fb-46d9-a66b-f6b94a0c23c6.png`, true);
    updateMetaTag('og:type', 'website', true);
    if (config.canonical) {
      updateMetaTag('og:url', config.canonical, true);
    }

    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', config.twitterTitle || config.title || '');
    updateMetaTag('twitter:description', config.twitterDescription || config.description || '');
    updateMetaTag('twitter:image', config.twitterImage || config.ogImage || `${SITE_URL}/lovable-uploads/924a6ca1-11fb-46d9-a66b-f6b94a0c23c6.png`);
    updateMetaTag('twitter:site', '@proptpilot');
    if (config.canonical) {
      updateMetaTag('twitter:url', config.canonical);
    }

    if (config.canonical) {
      updateCanonical(config.canonical);
    }
  }, [config]);
};
